module.exports = __webpack_public_path__ + "static/media/Barbell.53daa2c2.svg";